"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _Pc = require("@jobmatchme/amplify-tools/es/provider/Pc");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Headline = _interopRequireDefault(require("@jobmatchme/ui/es/components/Form/Headline"));

var _Authentication = require("../../provider/Authentication");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var translateNs = 'pc-matching:AccountVerification';

var AccountVerification = function AccountVerification() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      _useTranslation2 = (0, _slicedToArray2.default)(_useTranslation, 1),
      t = _useTranslation2[0];

  var _useAmplifyUser = (0, _Pc.useAmplifyUser)(),
      user = _useAmplifyUser.user,
      isAuthenticated = _useAmplifyUser.isAuthenticated;

  var _useContext = (0, _react.useContext)(_Authentication.AuthenticationActionsContext),
      resendVerificationEmail = _useContext.resendVerificationEmail;

  var _ref = user || {},
      attributes = _ref.attributes;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      btnAnimate = _useState2[0],
      setBtnAnimate = _useState2[1];

  var onClick = function onClick() {
    setBtnAnimate(1);
    resendVerificationEmail(user.username);
    setTimeout(function () {
      setBtnAnimate(2);
    }, 1000);
  };

  if (!isAuthenticated) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    className: _styleModule.default.accountVerification,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
      center: false,
      text: t("".concat(translateNs, ".verification"))
    }, "headline2"), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
      component: "p",
      className: _styleModule.default.text,
      children: [t(attributes['email_verified'] ? "".concat(translateNs, ".verified") : "".concat(translateNs, ".unverified")), "\xA0", /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: attributes['email']
      })]
    }), attributes['email_verified'] || /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: _styleModule.default.buttonWrapper,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: "primary",
        variant: "contained",
        round: true,
        flat: true,
        bold: true,
        texttransform: "none",
        onClick: onClick,
        className: _styleModule.default.button,
        loading: {
          start: btnAnimate === 1,
          end: btnAnimate === 2,
          animate: true
        },
        children: t("".concat(translateNs, ".verify"))
      })
    })]
  });
};

var _default = AccountVerification;
exports.default = _default;